package com.vizio.redwolf.utils

data class ECommerceEnvironmentConfig(val environmentGroup: EnvironmentGroup, val apiKey: String, val messageTokenAESKeyMasked: String?)